import { URL_REPLACEMENT } from '$const';
import { get, post } from '~services/api/methods';

export async function fetchDuplicateFormSettings(assetId: string) {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/one2edit/document/duplicate/${assetId}`;
  const response = await get(requestUrl);
  return response;
}

export async function postDuplicateDocument(assetId: string, data: object) {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/one2edit/document/duplicate/${assetId}`;
  const response = await post(requestUrl, data);
  return response;
}

export async function setSkipIntro() {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/one2edit/set_skip_intro`;
  const response = await post(requestUrl, {});
  return response;
}
